import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



// 公共路由
export const constantRoutes = [{
    path: '/',
    component: () =>
        import ('@/views/hhshx.vue'),
}, ]



// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})